import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M16.09 11.65A5.462 5.462 0 0018 7.5C18 4.47 15.53 2 12.5 2H5v20h8.5c3.03 0 5.5-2.47 5.5-5.5 0-2.09-1.18-3.92-2.91-4.85zM8 4h3.5C13.43 4 15 5.57 15 7.5S13.43 11 11.5 11H8V4zm4.5 16H8v-7h4.5c1.93 0 3.5 1.57 3.5 3.5S14.43 20 12.5 20z" }));
export default createSvgIcon(iconPath, "Bold");
//# sourceMappingURL=BoldIcon.js.map